var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcSort(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 11,
    viewBox: "0 0 12 11",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#585B63",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m9.31 10.518 2.55-2.353c.146-.159.207-.465.038-.643-.167-.176-.49-.17-.656.005L9.45 9.18V1.079A.446.446 0 0 0 9 .638a.446.446 0 0 0-.45.441v8.102L6.76 7.527c-.155-.151-.489-.179-.657-.005-.169.174-.115.49.037.643l2.55 2.353c.088.08.19.12.31.12a.51.51 0 0 0 .31-.12zM3 .638a.51.51 0 0 0-.31.12L.14 3.11c-.146.16-.207.465-.038.644.167.175.49.17.656-.005L2.55 2.095v8.102c0 .243.202.44.45.44.249 0 .45-.197.45-.44V2.095l1.79 1.654c.155.15.489.178.657.005.169-.174.115-.49-.037-.644L3.309.757a.438.438 0 0 0-.31-.12z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcSort);
export default __webpack_public_path__ + "static/media/ic_sort.576770582bce70d4d650c23d5f20a2ea.svg";
export { ForwardRef as ReactComponent };